import React from 'react';
import { FaGlobeAsia, FaUsers, FaPlane, FaLightbulb } from 'react-icons/fa';

const MissionSection = () => {
  return (
    <div>
      <link
        href="https://unpkg.com/tailwindcss@2.2.19/dist/tailwind.min.css"
        rel="stylesheet"
      ></link>

      <section
        className="
          relative 
          py-20 px-6 md:px-20
          bg-gradient-to-br from-[#0B1E34] via-[#132F4C] to-[#0B1E34]
          text-white
        "
      >
        <div className="max-w-7xl mx-auto">
          
          {/* Glass Header */}
          <div className="bg-white/10 backdrop-blur-md rounded-xl p-8 shadow-xl border border-white/20">
            <h2 className="text-4xl md:text-5xl font-extrabold text-center mb-4 text-teal-300">
              Our Mission
            </h2>
            <p className="text-center max-w-2xl mx-auto text-lg md:text-xl text-gray-200">
              At <strong>BookTrip4Me</strong>, we redefine travel using 
              innovation, personalization, and unmatched reliability —
              making every journey unforgettable.
            </p>
          </div>

          <br />

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 text-center mt-10">
            
            {/* CARD 1 */}
            <div className="
              bg-white/10 
              text-white 
              rounded-xl 
              p-6 
              shadow-lg 
              border border-white/10
              backdrop-blur-lg
              transform hover:-translate-y-2 hover:shadow-2xl
              transition duration-300
            ">
              <FaGlobeAsia className="text-5xl text-teal-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Global Reach</h3>
              <p className="text-sm text-gray-200">
                Connecting travelers to destinations across the globe with ease and trust.
              </p>
            </div>

            {/* CARD 2 */}
            <div className="
              bg-white/10 
              text-white 
              rounded-xl 
              p-6 
              shadow-lg 
              border border-white/10
              backdrop-blur-lg
              transform hover:-translate-y-2 hover:shadow-2xl
              transition duration-300
            ">
              <FaUsers className="text-5xl text-cyan-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Customer First</h3>
              <p className="text-sm text-gray-200">
                We put you at the center of everything — every booking, every time.
              </p>
            </div>

            {/* CARD 3 */}
            <div className="
              bg-white/10 
              text-white 
              rounded-xl 
              p-6 
              shadow-lg 
              border border-white/10
              backdrop-blur-lg
              transform hover:-translate-y-2 hover:shadow-2xl
              transition duration-300
            ">
              <FaPlane className="text-5xl text-indigo-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Hassle-free Travel</h3>
              <p className="text-sm text-gray-200">
                From flights to stays — we make every step smooth and enjoyable.
              </p>
            </div>

            {/* CARD 4 */}
            <div className="
              bg-white/10 
              text-white 
              rounded-xl 
              p-6 
              shadow-lg 
              border border-white/10
              backdrop-blur-lg
              transform hover:-translate-y-2 hover:shadow-2xl
              transition duration-300
            ">
              <FaLightbulb className="text-5xl text-yellow-300 mx-auto mb-4" />
              <h3 className="text-xl font-semibold mb-2">Innovation Driven</h3>
              <p className="text-sm text-gray-200">
                Smart technology & personalized recommendations to elevate your journey.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default MissionSection;
